/**
 * Image Component: How-To Schema
 *
 *  @param {string} props
 */
const HowToChildIconImage = (props) => {
	const { attributes } = props;

	let urlChk = '';
	if (
		typeof attributes.iconImage !== 'undefined' &&
		attributes.iconImage !== null &&
		attributes.iconImage !== ''
	) {
		urlChk = attributes.iconImage.url;
	}

	let url = '';
	if (urlChk !== '') {
		const size = attributes.iconImage.sizes;
		const imageSize = attributes.imageSize;

		if (
			typeof size !== 'undefined' &&
			typeof size[imageSize] !== 'undefined'
		) {
			if( typeof attributes.imageWidthType !== 'undefined' && attributes.imageWidthType && typeof size['full'] !== 'undefined' ) {
				url = size['full'].url;
			} else {
				url = size[imageSize].url;
			}
		} else {
			url = urlChk;
		}

		return (
			<div className="wpsp-ifb-image-icon-content wpsp-ifb-imgicon-wrap">
				<div className="wpsp-ifb-image">
					<div className="wpsp-ifb-image-content">
						<img
							className=""
							src={url}
							alt={attributes.iconImage.alt}
						/>
					</div>
				</div>
			</div>
		);
	}
	return null;
};

export default HowToChildIconImage;
